module.exports = __webpack_public_path__ + "images/5e0d515ce4c08b8e25831faef1ae77ed2.svg";